import { isEmpty } from 'lodash';

import { TagMatchMode } from 'enums/common.enum';

/**
 * POM-6330 — Exact / Contains for the Tags filter on the Bulk, Order Verification and
 * Prescription Review queues.
 *
 * Exact is the default and is never sent: core treats an omitted mode as EXACT, which is what the
 * queues have always done and what the urgent print view depends on (an URGENT + OUT_OF_STOCK
 * item must stay out of it). Only Contains travels, and only alongside selected tags — with no
 * tags there is nothing to match, and a mode left behind in the stored filter would silently
 * widen the next tag selection, e.g. the Urgent quick view.
 */
export const tagMatchModeForFilter = (mode, tags) =>
  mode === TagMatchMode.CONTAINS_ALL && !isEmpty(tags) ? TagMatchMode.CONTAINS_ALL : undefined;

/** What the dropdown shows for a stored filter: Contains only if it was sent, else Exact. */
export const tagMatchModeFormValue = (filter) =>
  filter?.tagMatchMode === TagMatchMode.CONTAINS_ALL
    ? TagMatchMode.CONTAINS_ALL
    : TagMatchMode.EXACT;

/** The Tags chip's name, so a Contains filter reads differently from an Exact one. */
export const tagsChipName = (filter) =>
  filter?.tagMatchMode === TagMatchMode.CONTAINS_ALL ? 'Tags Contain' : 'Tags';
